import { Link } from 'react-router-dom';
import styles from './index.module.scss';
import SiteTopNav from '@/components/SiteTopNav';
import img_guide_featured_hardwood from '@/assets/images/autumn-harvest-collection.png';
import { buyingGuideArticles } from '../buyingGuideArticles';

const FlooringGuide = () => {
  return (
    <div className={styles['flooring-guide-page']}>
      <div className={styles.page}>
        <section className={styles['guide-hero']}>
          <div className={styles['guide-hero__overlay']}>
            <SiteTopNav />
          </div>
        </section>

        <main className={styles['guide-main']}>
          <section className={styles['guide-intro']}>
            <p className={styles['guide-intro__eyebrow']} data-motion="copy">
              Sakura Floors Academy
            </p>
            <h1 className={styles['guide-intro__title']} data-motion="hero">
              Flooring 101
            </h1>
            <p className={styles['guide-intro__lead']} data-motion="copy">
              A short education on choosing engineered flooring with confidence — from grain and
              finish to the right fit for every room in your home.
            </p>
          </section>

          <section className={styles['guide-featured']} aria-label="Featured article">
            <div className={styles['guide-featured__text']}>
              <h2 className={styles['guide-featured__title']} data-motion="title">
                What Is Engineered Hardwood?
              </h2>
              <p className={styles['guide-featured__excerpt']} data-motion="copy">
                Engineered hardwood is real hardwood flooring made with a genuine hardwood top layer
                bonded to multiple layers of high-quality plywood. This construction provides the
                natural beauty of solid wood while offering greater stability, making it more
                resistant to moisture and temperature changes. It can often be installed over
                concrete, radiant heat, and below grade, depending on the product.
              </p>
              <Link
                className={styles['guide-featured__cta']}
                to="/academy/hardwood-basics/what-is-hardwood-flooring"
                data-motion-interactive="press"
              >
                <span className={styles['guide-featured__ctaLabel']}>Read More</span>
              </Link>
            </div>
            <div className={styles['guide-featured__media']}>
              <img
                className={styles['guide-featured__image']}
                alt="Hardwood flooring in a bright, elegant living space"
                referrerPolicy="no-referrer"
                src={img_guide_featured_hardwood}
              />
            </div>
          </section>

          <section className={styles['guide-featured']} aria-label="Featured article">
            <div className={styles['guide-featured__media']}>
              <img
                className={styles['guide-featured__image']}
                alt="Hardwood flooring in a bright, elegant living space"
                referrerPolicy="no-referrer"
                src="https://cdn.sakurafloors.com/assets/gallery/Harvest_Moon_Select_Living.png"
              />
            </div>
            <div className={styles['guide-featured__text']}>
              <h2 className={styles['guide-featured__title']} data-motion="title">
                How Engineered Hardwood Is Made?
              </h2>
              <p className={styles['guide-featured__excerpt']} data-motion="copy">
                Engineered hardwood flooring is the result of combining nature's finest materials
                with modern engineering. While every plank showcases the beauty of genuine hardwood,
                its layered construction is carefully designed to deliver exceptional stability,
                durability, and long-term performance.
              </p>
              <Link
                className={styles['guide-featured__cta']}
                to="/academy/hardwood-basics/how-engineered-hardwood-is-made"
                data-motion-interactive="press"
              >
                <span className={styles['guide-featured__ctaLabel']}>Read More</span>
              </Link>
            </div>
          </section>

          {buyingGuideArticles.map((article, index) => {
            const text = (
              <div className={styles['guide-featured__text']}>
                <h2 className={styles['guide-featured__title']} data-motion="title">
                  {article.title}
                </h2>
                <p className={styles['guide-featured__excerpt']} data-motion="copy">
                  {article.excerpt}
                </p>
                <Link
                  className={styles['guide-featured__cta']}
                  to={article.to}
                  data-motion-interactive="press"
                >
                  <span className={styles['guide-featured__ctaLabel']}>Read More</span>
                </Link>
              </div>
            );
            const media = (
              <div className={styles['guide-featured__media']}>
                <img
                  className={styles['guide-featured__image']}
                  alt={article.imageAlt}
                  referrerPolicy="no-referrer"
                  src={article.image}
                />
              </div>
            );
            return (
              <section
                key={article.to}
                className={styles['guide-featured']}
                aria-label={article.label}
              >
                {index % 2 === 0 ? (
                  <>
                    {text}
                    {media}
                  </>
                ) : (
                  <>
                    {media}
                    {text}
                  </>
                )}
              </section>
            );
          })}
        </main>
      </div>
    </div>
  );
};

export default FlooringGuide;
